import React from 'react';

import Typography from '@mui/material/Typography';

import {
    DividerContainer,
    InfoEditButtonContainer,
} from './styledInfoComponents';
import { ButtonText } from 'ff/debrief/common/components/StyledComponents/Buttons';

type Props = {
    label: string;
} & (
    | {
          editable?: false;
      }
    | {
          editable: true;
          onEditClick: () => void;
          onCancelClick: () => void;
          onSaveClick: () => Promise<void>;
      }
);
const InfoDivider: React.FC<Props> = props => {
    const [isEditing, setIsEditing] = React.useState(false);
    const [isSaving, setIsSaving] = React.useState(false);

    const editClickHandler = () => {
        if (props.editable) {
            setIsEditing(true);
            props.onEditClick();
        }
    };

    const cancelClickHandler = () => {
        if (props.editable) {
            setIsEditing(false);
            props.onCancelClick();
        }
    };

    const saveClickHandler = () => {
        if (props.editable) {
            props
                .onSaveClick()
                .then(() => {
                    setIsEditing(false);
                    setIsSaving(false);
                })
                .catch(() => {
                    setIsEditing(false);
                    setIsSaving(false);
                });
        }
    };

    return (
        <DividerContainer>
            <Typography
                fontSize="11px"
                fontWeight="700"
                textTransform="uppercase"
            >
                {props.label}
            </Typography>
            {props.editable && (
                <InfoEditButtonContainer>
                    {isEditing ? (
                        <>
                            <ButtonText
                                type="button"
                                disabled={isSaving}
                                onClick={cancelClickHandler}
                            >
                                Cancel
                            </ButtonText>
                            <ButtonText
                                type="button"
                                disabled={isSaving}
                                onClick={saveClickHandler}
                            >
                                Save
                            </ButtonText>
                        </>
                    ) : (
                        <ButtonText type="button" onClick={editClickHandler}>
                            Edit
                        </ButtonText>
                    )}
                </InfoEditButtonContainer>
            )}
        </DividerContainer>
    );
};

export default InfoDivider;
